import { render, staticRenderFns } from "./UserVersionCardContent.vue?vue&type=template&id=1c33818a&"
import script from "./UserVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./UserVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports